import type { SVGProps } from 'react';

export const CheckmarkSFSymbolMedium = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      height="1em"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 17.6199 17.4086"
      fill="currentColor"
      {...props}
    >
      <g>
        {' '}
        <rect height="17.4086" opacity="0" width="17.6199" x="0" y="0" />{' '}
        <path
          d="M6.60448 17.4086C7.11229 17.4086 7.51287 17.1967 7.79119 16.7721L16.9705 2.46229C17.1762 2.14042 17.2586 1.87109 17.2586 1.60605C17.2586 0.933592 16.7857 0.469534 16.1062 0.469534C15.6242 0.469534 15.3443 0.631642 15.052 1.09062L6.56542 14.5731L2.19217 8.95C1.9076 8.57305 1.60897 8.41524 1.1871 8.41524C0.489839 8.41524 0 8.90332 0 9.57754C0 9.86718 0.108203 10.1598 0.351755 10.4557L5.41133 16.7859C5.74824 17.2072 6.11249 17.4086 6.60448 17.4086Z"
          fill="currentColor"
        />{' '}
      </g>
    </svg>
  );
};
